// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App'
import router from './router'
import axios from 'axios'
import vueg from 'vueg'
import store from '@/store/'
import throttle from 'lodash/throttle'
import debounce from 'lodash/debounce'
import VueLazyload from 'vue-lazyload'
import * as VueGoogleMaps from 'vue2-google-maps'
// import VueTouch from 'vue-touch'

// Vue.use(VueTouch, {name: 'v-touch'})

import 'vueg/css/transition-min.css'

Vue.use(Vuetify)
Vue.use(VueLazyload, {
  error: 'static/photo.png',
  loading: 'static/loading.gif'
})
Vue.use(vueg, router, {shadow: false, forwardAnim: 'fadeInRightBig', backAnim: 'fadeInLeftBig', duration: '0.5'})
Vue.use(VueGoogleMaps, {
  load: {
    // key: 'AIzaSyBXlZCE_7QzPlyA984CNVmKDinOAsPD-BU',
    key: 'AIzaSyBXHTApQxC7eBOhAUSi5kiniwnOdztCyKY',
    v: '3'
  }
})

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$throttle = throttle
Vue.prototype.$debounce = debounce

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js